const Accounting = {
  IncomeStatement: "Accounting.IncomeStatement",
  FinancialYear: "Accounting.FinancialYear",
  FinancialYear2: "Accounting.FinancialYear2",
  PreviousFinancialYear: "Accounting.PreviousFinancialYear",
  CurrentFinancialYear: "Accounting.CurrentFinancialYear",
  Last12Months: "Accounting.Last12Months",
  Previous12Months: "Accounting.Previous12Months",
  Last3Months: "Accounting.Last3Months",
  CurrentMonth: "Accounting.CurrentMonth",
  LastMonth: "Accounting.LastMonth",
  PreviousMonth: "Accounting.PreviousMonth",
  PreviousYearMonth: "Accounting.PreviousYearMonth",
  Prior12Months: "Accounting.Prior12Months",
  Prior1Month: "Accounting.Prior1Month",
  Prior3Months: "Accounting.Prior3Months",
  Prior24Months: "Accounting.Prior24Months",
  FinancialReportType_0: "Accounting.FinancialReportType_0",
  FinancialReportType_1: "Accounting.FinancialReportType_1",
  FinancialReportType_2: "Accounting.FinancialReportType_2",
  BalanceSheet: "Accounting.BalanceSheet",
  RecipientOrSender: "Accounting.RecipientOrSender",
  Change: "Accounting.Change",
  Asset: "Accounting.Asset",
  ShareHoldersEquity: "Accounting.ShareHoldersEquity",
  Liability: "Accounting.Liability",
  AssetAllocation: "Accounting.AssetAllocation",
  LiabilityAllocation: "Accounting.LiabilityAllocation",
  Revenue: "Accounting.Revenue",
  Cost: "Accounting.Cost",
  AssetIncreased: "Accounting.AssetIncreased",
  AssetDecreased: "Accounting.AssetDecreased",
  ShareHoldersEquityIncreased: "Accounting.ShareHoldersEquityIncreased",
  ShareHoldersEquityDecreased: "Accounting.ShareHoldersEquityDecreased",
  LiabilityIncreased: "Accounting.LiabilityIncreased",
  LiabilityDecreased: "Accounting.LiabilityDecreased",
  RevenueIncreased: "Accounting.RevenueIncreased",
  RevenueDecreased: "Accounting.RevenueDecreased",
  CostIncreased: "Accounting.CostIncreased",
  CostDecreased: "Accounting.CostDecreased",
  Series: "Accounting.Series",
  ManualPayment: "Accounting.ManualPayment",
  OnlyDimensionsWithTransactions: "Accounting.OnlyDimensionsWithTransactions",
  OnlyActiveDimensions: "Accounting.OnlyActiveDimensions",
  ShowAccount: "Accounting.ShowAccount",
  HideAverageMonthAndDifference: "Accounting.HideAverageMonthAndDifference",
  Reconciliation: "Accounting.Reconciliation",
  AccountingDoneUntil: "Accounting.AccountingDoneUntil",
  DocumentsAreBooked: "Accounting.DocumentsAreBooked",
  BankAccountsAreReconciled: "Accounting.BankAccountsAreReconciled",
  TagsXDescription: "Accounting.TagsXDescription",
  TagsYDescription: "Accounting.TagsYDescription",
  TimeLineStepResponsiblePerson_Wint: "Accounting.TimeLineStepResponsiblePerson_Wint",
  TimeLineStepResponsiblePerson_Customer: "Accounting.TimeLineStepResponsiblePerson_Customer",
  TimeLineStepResponsiblePerson_Revisor: "Accounting.TimeLineStepResponsiblePerson_Revisor",
  TimeLineStepResponsiblePerson_External: "Accounting.TimeLineStepResponsiblePerson_External",
  ExportAttachments: "Accounting.ExportAttachments",
  CreateExport: "Accounting.CreateExport",
  CreateExportDialogMessage: "Accounting.CreateExportDialogMessage",
  CreateExportStartedMessage: "Accounting.CreateExportStartedMessage",
  StartExport: "Accounting.StartExport",
  CompletedExports: "Accounting.CompletedExports",
  VoucherNumber: "Accounting.VoucherNumber",
  SeriesExportHeader: "Accounting.SeriesExportHeader",
  }
export default Accounting;